import { Box, FormLabel, styled } from "@mui/material";

export const Container = styled(Box)({
  position: "absolute",
  top: 5,
  left: 60,
  display: "flex",
  flexDirection: "column",
});

export const Row = styled(Box, {
  shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  cursor: "pointer",
  paddingRight: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  backgroundColor: selected ? theme.palette.action.selected : "transparent",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const Label = styled(FormLabel, {
  shouldForwardProp: (prop) => prop !== "editing",
})<{ editing?: boolean }>(({ theme, editing }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 0,
  m: 0,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: editing ? 600 : 400,
}));
